/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useState, useCallback, Suspense, useRef, useEffect, useContext } from "react";

import { Tooltip, IconButton, Button } from "@material-ui/core";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { trackPromise } from "react-promise-tracker";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { AuthContext } from "../../../../../../../contexts";
import ROLES from "../../../../../../../constants/roles";
import CustomGridDialog from "../../../../../../shared/dialogs/customGridDialog/CustomGridDialog";
import { CustomDatePickerDialog } from "../../../../../../shared";
import getAgGridHeight from "../../../../../../../utils/commonFunctions/getAgGridHeight";
import { OpenEnrollmentsGridProps } from "../../../../../../../@types/components/openEnrollmentProps.types";
import {
	handleDateCellRenderer,
	handleNameCellRenderer
} from "../../../../../../../utils/commonFunctions/cellRenderers";
import { handleCapitalizeCellRenderer } from "../../../../../../../utils/commonFunctions/cellRenderers";
import { OpenEnrollmentStatusQuery } from "../../../../../../../utils/api/openEnrollment/openEnrollment";
import { OpenEnrollment } from "../../../../../../../@types/openEnrollment.types";
import { api } from "../../../../../../../utils/api";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import CustomOpenEnrollmentEmployeesDialog from "../../../../plan/openEnrollments/customOpenEnrollmentEmployeesDetailsDialog/CustomOpenEnrollmentEmployeesDialog";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

const OpenEnrollmentListsGrid = ({ openEnrollments }: any) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("400px");
	const agGridRef = useRef<any>(null);
	const { user } = useContext(AuthContext);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
	};

	// const handleStatusCellRenderer = () => {
	// 	return <div>{initCapitalize(status)}</div>;
	// };

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	useEffect(() => {
		const _gridHeight = getAgGridHeight(openEnrollments.length);
		setGridHeight(_gridHeight);
	}, [openEnrollments.length]);

	return (
		<>
			<div className="all-enrollments-grid-conatiner grid-margin">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={openEnrollments}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						animateRows
						suppressColumnVirtualisation={true}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true,
							floatingFilterComponentParams: { suppressFilterButton: true }
						}}
						frameworkComponents={{
							handleDateCellRenderer: handleDateCellRenderer,
							// handleStatusCellRenderer: handleStatusCellRenderer,
							handleCapitalizeCellRenderer: handleCapitalizeCellRenderer,
							handleNameCellRenderer: handleNameCellRenderer
						}}
					>
						{user &&
						user.role === ROLES.super_admin &&
						((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
							(user.first_name === "Anupam" && user.last_name === "Biswas") ||
							(user.first_name === "Rahul" && user.last_name === "Dutta") ||
							(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
							<AgGridColumn
								field="group_number"
								headerName="Group Number"
								suppressSizeToFit
							></AgGridColumn>
						) : null}
						<AgGridColumn field="plan_code" headerName="Plan Code" suppressSizeToFit={true}></AgGridColumn>
						<AgGridColumn field="plan_name" headerName="Plan Name" suppressSizeToFit={true}></AgGridColumn>
						<AgGridColumn
							field="open_enrollment_for"
							headerName="Open For"
							cellRenderer="handleCapitalizeCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="type"
							headerName="Enrollment Type"
							cellRenderer="handleCapitalizeCellRenderer"
							suppressSizeToFit={true}
						></AgGridColumn>
						<AgGridColumn
							field="start_date"
							headerName="Start Date"
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="end_date"
							headerName="End Date"
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						{/* <AgGridColumn
							field="status"
							// cellRenderer="handleStatusCellRenderer"
							headerName="Status"
							filter={false}
						></AgGridColumn> */}
						<AgGridColumn
							field="group_owners"
							headerName="Plan Opened By"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
							cellRenderer="handleNameCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="plan_opened_on"
							headerName="Plan Opened on"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</>
	);
};

export default OpenEnrollmentListsGrid;
